export default __webpack_public_path__ + "static/media/icon-circle-white-border.7f987c1a.svg";